"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCategorie = void 0;
const react_1 = __importStar(require("react"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const Input_1 = require("../../../Shared/Input");
const GoogleInput_1 = __importDefault(require("../../../Shared/GoogleInput"));
const DropzoneMedia_1 = __importDefault(require("../../../Shared/DropzoneMedia"));
const MyDropzoneFile_1 = require("../../../Shared/MyDropzoneFile");
const ci_1 = require("react-icons/ci");
const UseCrudEspace_1 = __importDefault(require("../requestForm/UseCrudEspace"));
function AddOrUpdateSpaceModal({ show, handleClose, item, }) {
    var _a, _b, _c, _d;
    // console.log("espace", item)
    const { register, errors, onSubmit, setValue, isLoading, address, onChangeAddress, imageFile, setImageFile, categories } = (0, UseCrudEspace_1.default)(handleClose, item);
    return (react_1.default.createElement(Modal_1.default, { show: show, onHide: handleClose, className: "custom__modal", size: "lg" },
        react_1.default.createElement(Modal_1.default.Header, { className: "modal-header-wrapper", closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, { className: "modal-title-custom" },
                !!item ? "Modifier" : "Ajouter",
                " un espace")),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "form-wrapper" },
                react_1.default.createElement("form", { onSubmit: onSubmit },
                    react_1.default.createElement("div", { className: "form-content" },
                        react_1.default.createElement("div", { className: "row infos-row" },
                            react_1.default.createElement("div", { className: "col-md-12 mb-3 custom-wrapper" },
                                react_1.default.createElement("label", { htmlFor: "__category", className: "form-label form-label-formule" }, "S\u00E9lectionnez une cat\u00E9gorie"),
                                react_1.default.createElement("div", { className: "catgories" },
                                    react_1.default.createElement(exports.RadioCategorie, { categories: categories, setValue: setValue, defaultValue: (_a = item === null || item === void 0 ? void 0 : item.category_id) !== null && _a !== void 0 ? _a : null }),
                                    react_1.default.createElement(Input_1.FormError, { error: (_b = errors === null || errors === void 0 ? void 0 : errors.category_id) === null || _b === void 0 ? void 0 : _b.message }))),
                            react_1.default.createElement("div", { className: "col-lg-12 col-md-12 mb-3 custom-wrapper" },
                                react_1.default.createElement(Input_1.Input, Object.assign({ label: "Nom de l\u2019espace", type: "text", id: "__space_name", placeholder: "Nom de l\u2019espace" }, register("name"), { error: errors === null || errors === void 0 ? void 0 : errors.name }))),
                            react_1.default.createElement("div", { className: "col-lg-12 col-md-12 mb-3 custom-wrapper" },
                                react_1.default.createElement("label", { htmlFor: "__category", className: "form-label form-label-formule" }, "Ajouter une photo"),
                                react_1.default.createElement(DropzoneMedia_1.default, { setFiles: setImageFile, label: "S\u00E9lectionnez une image", acceptFile: { "image/*": [] }, icon: react_1.default.createElement(ci_1.CiImageOn, { style: {
                                            color: "#0088CE",
                                            fontSize: "28px",
                                        } }) }),
                                react_1.default.createElement(Input_1.FormError, { error: (_c = errors === null || errors === void 0 ? void 0 : errors.image) === null || _c === void 0 ? void 0 : _c.message }),
                                imageFile && (react_1.default.createElement("div", { className: "mt-3" },
                                    react_1.default.createElement(MyDropzoneFile_1.RenderFile, { file: imageFile })))),
                            react_1.default.createElement("div", { className: "col-lg-6 col-md-12 mb-3 custom-wrapper" },
                                react_1.default.createElement("label", { htmlFor: "__address", className: "form-label form-label-formule" }, "Adresse"),
                                react_1.default.createElement(GoogleInput_1.default, { placeholder: "Adresse compl\u00E8te", value: address, onChange: onChangeAddress, className: "form-control form-control-input-formule modal__input" }),
                                react_1.default.createElement(Input_1.FormError, { error: (_d = errors === null || errors === void 0 ? void 0 : errors.address) === null || _d === void 0 ? void 0 : _d.message })),
                            react_1.default.createElement("div", { className: "col-lg-6 col-md-12 mb-3 custom-wrapper" },
                                react_1.default.createElement("label", { htmlFor: "__address", className: "form-label form-label-formule" }, "Coordonn\u00E9s GPS"),
                                react_1.default.createElement("div", { className: "row" },
                                    react_1.default.createElement("div", { className: "col-6" },
                                        react_1.default.createElement(Input_1.Input
                                        // label="Latitude"
                                        , Object.assign({ 
                                            // label="Latitude"
                                            type: "text", id: "__space_latitude", placeholder: "Latitude" }, register("lat"), { error: errors === null || errors === void 0 ? void 0 : errors.lat }))),
                                    react_1.default.createElement("div", { className: "col-6" },
                                        react_1.default.createElement(Input_1.Input
                                        // label="Longitude"
                                        , Object.assign({ 
                                            // label="Longitude"
                                            type: "text", id: "__space_longitude", placeholder: "Longitude" }, register("long"), { error: errors === null || errors === void 0 ? void 0 : errors.long }))))))),
                    react_1.default.createElement("div", { className: "btn-wrapper d-flex justify-content-end gap-3 mt-5" },
                        react_1.default.createElement("button", { type: "button", className: "btn cancel__btn custom", onClick: handleClose }, "Annuler"),
                        react_1.default.createElement("button", { type: "submit", className: "sunu-autoroute-admin-btn-add custom", disabled: isLoading }, isLoading ? (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
                            react_1.default.createElement("i", { className: "fa fa-spinner fa-spin " }),
                            react_1.default.createElement("span", null, !!item
                                ? "Modification..."
                                : "Enregistrement..."))) : item ? ("Modifier") : ("Enregistrer"))))))));
}
const RadioCategorie = ({ categories, setValue, setType, defaultValue, }) => {
    const [selectedId, setSelectedId] = (0, react_1.useState)(defaultValue || null);
    (0, react_1.useEffect)(() => {
        if (defaultValue) {
            setSelectedId(defaultValue);
            setValue("category_id", defaultValue);
        }
    }, [defaultValue, setValue]);
    return (react_1.default.createElement("div", { className: "d-flex gap-3 custom-logement-comtainer" }, !!(categories === null || categories === void 0 ? void 0 : categories.length) && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 ? (categories === null || categories === void 0 ? void 0 : categories.map((category) => (react_1.default.createElement("label", { key: category.id, className: `card-logement p-0 ${selectedId === category.id ? "custom-selected" : ""}`, style: {
            // width: "150px",
            cursor: "pointer",
        } },
        react_1.default.createElement("input", { type: "radio", name: "logement", value: category.id, checked: selectedId === category.id, onChange: () => {
                setSelectedId(category.id);
                setValue("category_id", category.id);
                setType && setType(category === null || category === void 0 ? void 0 : category.name);
            }, className: "d-none" }),
        react_1.default.createElement("div", { className: "card-logement-card-body px-3 py-2" },
            react_1.default.createElement("p", { className: "card-logement-card-text mb-0" }, category.name)))))) : (
    //   <AlertInfo message="Aucun logement trouvé" />
    react_1.default.createElement("div", null, "Aucune donn\u00E9e trouv\u00E9"))));
};
exports.RadioCategorie = RadioCategorie;
const categories = [
    {
        id: 1,
        label: "Remorquage",
    },
    {
        id: 2,
        label: "Point de vente",
    },
    {
        id: 3,
        label: "Information",
    },
    {
        id: 4,
        label: "Péage",
    },
    {
        id: 5,
        label: "Carburant",
    },
    {
        id: 6,
        label: "Parking",
    },
    {
        id: 7,
        label: "Lavage Auto",
    },
    {
        id: 8,
        label: "GAB",
    },
    {
        id: 9,
        label: "Boutique",
    },
    {
        id: 10,
        label: "Espace prière",
    },
    {
        id: 11,
        label: "Gendarmerie",
    },
    {
        id: 12,
        label: "Ajouter",
    },
];
exports.default = AddOrUpdateSpaceModal;
